import type { ReactNode } from 'react'

import { Card } from '../components/ui'

/** The frame around every unauthenticated screen. Brand mint as a **surface**
 *  only — the logo mint is 1.65:1 on white and is never text or a stroke. */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full" style={{ maxWidth: '26rem' }}>
        <div className="mb-6 text-center">
          <span className="block text-lg font-bold tracking-tight">Phony Content</span>
          <span className="block text-sm" style={{ color: 'var(--text-label)' }}>
            Analytics
          </span>
        </div>
        <Card>
          <h1 className="mb-4 mt-0 text-base font-semibold">{title}</h1>
          {children}
        </Card>
      </div>
    </div>
  )
}
